import { useState } from 'react'
import { FilterBar, Segmented } from '../components'
import { AccrualTab } from './salaries-accrual-tab'
import { ReportTab } from './salaries-report-tab'

type Tab = 'accrual' | 'report'

export function Salaries() {
  const [tab, setTab] = useState<Tab>('accrual')
  return (
    <>
      <FilterBar>
        <Segmented<Tab>
          options={[
            { value: 'accrual', label: 'Нарахування' },
            { value: 'report', label: 'Звіт' },
          ]}
          value={tab}
          onChange={setTab}
        />
      </FilterBar>
      <div className="content">{tab === 'accrual' ? <AccrualTab /> : <ReportTab />}</div>
    </>
  )
}
